import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  ISubscriptionUserUpdateInput,
  ISubscriptionUserUpdateRes,
} from '@shared/models/auth';

export const USER_UPDATE_SUBSCRIPTION: TypedDocumentNode<
  ISubscriptionUserUpdateRes,
  ISubscriptionUserUpdateInput
> = gql`
  subscription userUpdate {
    userUpdate {
      updated {
        id
        phoneNumberConfirmedAt
        emailConfirmedAt
        preference {
          id
          roles
          markets
          investmentStyles
          rehabComfortabilities
        }
      }
    }
  }
`;
